{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "หรัสผ่าน",
      "PLACEHOLDER": "หรัสผ่าน",
      "ERROR": "หรัสผ่านนั้นสั้นเกินไป."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "ยืนยันหรัสผ่าน",
      "ERROR": "หรัสผ่านไม่ตรงกัน."
    },
    "API": {
      "SUCCESS_MESSAGE": "เปลี่ยนหรัสผ่านเเล้ว.",
      "ERROR_MESSAGE": "Could not connect to Woot server. Please try again."
    },
    "CAPTCHA": {
      "ERROR": "การยืนยันหมดอายุ โปรดแก้ไขแคปช่าอีกครั้ง"
    },
    "SUBMIT": "ส่ง"
  }
}
